<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';
    import { fetchBodegas, saveBodega, removeBodega, searchBodegas, subscribeToBodegas, unsubscribeFromBodegas } from '../controllers/bodegaController.js';
    import { fetchSucursales } from '../controllers/sucursalController.js'; // Función para cargar las sucursales

    // Configuración de las columnas para la tabla de bodegas
    let bodegaColumns = [
      { label: 'Sucursal', field: 'sucursal_descrip', type: 'text' },
      { label: 'Descripción', field: 'descrip', type: 'text' },
      { label: 'Defecto', field: 'default', type: 'bool'  },
      { label: 'Estado', field: 'sta', type: 'bool' },
    ];

    // Estructura del nuevo objeto Bodega
    let newBodega = {
      sucursal: '',
      descrip: '',
      default: false,
      sta: true,
    };

    // Configuración de los campos para la edición de bodegas
    let editColumns = [
        { label: 'Sucursal', key: 'sucursal', type: 'select', required: true, fetchOptions: { key: 'id', value: 'descrip' }, options: [] },
        { label: 'Descripción', key: 'descrip', type: 'text', required: true },
        { label: 'Defecto', key: 'default', type: 'checkbox', required: false },
        { label: 'Estado', key: 'sta', type: 'checkbox', required: true }
    ];

    let sucursalOptions = [];

    // Función para cargar y transformar sucursales
    async function loadSucursales() {
        try {
            const fetchedSucursales = await fetchSucursales();

            if (Array.isArray(fetchedSucursales.sucursal)) {
                sucursalOptions = fetchedSucursales.sucursal.map(e => ({
                    key: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.key],
                    value: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.value],
                }));

                // Asigna las opciones transformadas a las columnas editables
                editColumns.find(column => column.key === 'sucursal').options = sucursalOptions;
            } else {
                console.error('Se esperaba un array de sucursales, pero se obtuvo:', fetchedSucursales);
            }
        } catch (error) {
            console.error('Error al cargar las sucursales:', error);
        }
    }

    // Cargar las sucursales al montar el componente
    onMount(() => {
        loadSucursales();
    });
</script>

<CRUD 
    title={$t('entities.bodegas')}
    entityName="bodega"
    newEntity={newBodega}
    columns={bodegaColumns}
    fetchEntities={fetchBodegas}
    saveEntity={saveBodega}
    removeEntity={removeBodega}
    searchEntities={searchBodegas}
    subscribeToChanges={subscribeToBodegas}
    unsubscribeFromChanges={unsubscribeFromBodegas}
    editColumns={editColumns}
/>